export default __webpack_public_path__ + "static/media/1.51324725.png";